import { Card } from "antd";
import { Box } from "@mui/material";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useState } from "react";

import { CardAction } from "./cardAction";
import { DocumentTable } from "./documentTable";
import { ReviewModal } from "./reviewModal";
import { ArchivedDocumentTable } from "./archivedDocumentTable";
import { ViewCheckrReportsButton } from "@src/containers/accountManagement/agentsOldUX/ViewCheckrReportsButton";
import { isDefined } from "@clipboard-health/util-ts";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'agent' implicitly has an 'any' type.
function UploadedDocs({ agent, onUpdateDocument, agentTMZ }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [selectedDoc, setSelectedDoc] = useState<any>(null);
  const onCancel = () => {
    setSelectedDoc(null);
    onUpdateDocument();
  };

  const onUpdated = () => {
    onUpdateDocument();
  };

  return (
    <>
      <Card
        title="Uploaded Docs"
        extra={<CardAction agentId={agent.userId} />}
        actions={[
          <Box key="checkr" sx={{ textAlign: "left", paddingX: 3 }}>
            <ViewCheckrReportsButton email={agent.email} />
          </Box>,
        ]}
      >
        <DocumentTable agentId={agent.userId} setSelectedDoc={setSelectedDoc} agentTMZ={agentTMZ} />
        <Box sx={{ marginTop: 4 }}>
          <ArchivedDocumentTable agentId={agent.userId} agentTMZ={agentTMZ} />
        </Box>
      </Card>
      <ReviewModal
        document={selectedDoc}
        onCancel={onCancel}
        visible={isDefined(selectedDoc)}
        onUpdated={onUpdated}
        agentTMZ={agentTMZ}
      />
    </>
  );
}

export { UploadedDocs };
